import type { MotorbikeAd } from "@mobility-item-page/types";
import { KeyInfo } from "../../key-info/KeyInfo.tsx";
import { AnnualTax } from "../AnnualTax.tsx";
import { ChassisNumber } from "../ChassisNumber.tsx";
import { Color } from "../Color.tsx";
import { Condition } from "../Condition.tsx";
import { ConditionReport } from "../ConditionReport.tsx";
import { Effect } from "../Effect.tsx";
import { Fuel } from "../Fuel.tsx";
import { Make } from "../Make.tsx";
import { Mileage } from "../Mileage.tsx";
import { Model } from "../Model.tsx";
import { ModelYear } from "../ModelYear.tsx";
import { Owners } from "../Owners.tsx";
import { RegistrationNumber } from "../RegistrationNumber.tsx";
import { RegistrationTax } from "../RegistrationTax.tsx";
import { SpecificationsArea } from "../SpecificationsArea.tsx";
import { VolumeCc } from "../VolumeCc.tsx";
import { Warranty } from "../Warranty.tsx";
import { Weight } from "../Weight.tsx";
import { Type } from "./Type.tsx";

export const MotorbikeSpecifications = ({ ad }: { ad: MotorbikeAd }) => {
  return (
    <SpecificationsArea>
      <KeyInfo>
        {/*Tax, price, etc.*/}
        <RegistrationTax
          registration_price={ad.price?.registration_price}
          main={ad.price?.net}
          registration_tax_exemption={ad.price?.registration_tax_exemption}
          registration_tax_url={ad.price?.registration_tax_url}
        />
        <AnnualTax annualTaxUrl={ad.annual_tax_url} />

        {/*General information*/}
        <Condition condition={ad.condition} />
        {ad.make && <Make make={ad.make.value} />}
        <Model model={ad.model} />
        <ModelYear year={ad.year} />
        <Type type={ad.type} />

        {/*Product properties*/}
        <Fuel fuel={ad.engine?.fuel} />
        <Effect effect={ad.engine?.effect} />
        <VolumeCc volume={ad.engine?.volume} />
        <Mileage distance={ad.mileage} unit={ad.mileage_unit} />
        <Weight weight={ad.weight} />

        {/*Appearance*/}
        <Color color={ad.color} />

        {/*Registration, warranty, owners, etc*/}
        <RegistrationNumber registrationNumber={ad.registration_number} />
        <ChassisNumber chassisNumber={ad.chassis_number} />
        <Owners owners={ad.owners} />
        <Warranty warranty={ad.warranty} />
        <ConditionReport conditionReport={ad.condition_report} />
      </KeyInfo>
    </SpecificationsArea>
  );
};
